
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/ai/tender-failures",
      function () {
        return require("private-next-pages/en/ai/tender-failures/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/ai/tender-failures"])
      });
    }
  